/**
 * @file FormRegistPassport
 */
'use strict';

/**
 * @classname FormRegistPassport
 * @classdesc 登録
 */
export default class FormRegistPassport {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof FormRegistration
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log('FormRegistPassport.preProcessing');
		// バリデーション後に行う処理を記載（開始）

        let cnt = 0;
        $('.toggle-check').each((idx, e)=> {
           const $e = $(e);
           if($e.prop('checked')) cnt ++;
        });
        if(cnt === 0){
            $('#service_name1')
                .addClass('is-invalid')
                .closest('.form-group')
                .find('.error-tip')
                .addClass('show')
                .children('.error-tip-inner')
                .html('<p>子育てサービスのサービス提供は少なくとも一つ選んでください。</p>');
            $('#service_name2').addClass('is-invalid');
            $('#service_name3').addClass('is-invalid');
            $('#service_name4').addClass('is-invalid');
            $('#service_name5').addClass('is-invalid');
            $('#service_name6').addClass('is-invalid');
            $('#service_name7').addClass('is-invalid');
            $('#service_name8').addClass('is-invalid');
            $('#service_name9').addClass('is-invalid');
            $('#service_name10').addClass('is-invalid');
        }


		// バリデーション後に行う処理を記載（終了）
		this._controller.completePreProcessing($form);
	};


	/**
	 * フォーム送信後処理
	 *
	 * @memberof FormRegistPassport
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log('FormRegistPassport.postProcessing');
		// バリデーション後に行う処理を記載（開始）

        // バリデーション後に行う処理を記載（終了）
        this._controller.completePostProcessing($form);
	};
}
